import React from 'react';
import { Row, Col } from 'reactstrap';
import { SubHeading, YesNoBadge } from '../common/forms/FormElements';
import moment from 'moment';
import { MomentDateFormat } from '../MomentDateFormat';
import LtsJobCard from '../longTermSchedule/LtsJobCard';

export class LongTermSchedulesForContract extends React.Component {
    render() {
        const { longTermSchedules, crews, divisions } = this.props;

        if (
            !longTermSchedules ||
            !longTermSchedules.length ||
            !crews ||
            !crews.length
        ) {
            return null;
        }

        return (
            <>
                <Row>
                    <Col>
                        <SubHeading>Long-Term Schedules</SubHeading>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <div className="container-fluid simple-table-container">
                            <table className="table table-sm">
                                <thead>
                                    <tr className="sticky-thead">
                                        <th>Crew</th>
                                        <th>Start Date</th>
                                        <th>End Date</th>
                                        <th>Published</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {longTermSchedules.map((lts) => {
                                        const crew = crews.find(
                                            (c) => c.id == lts.crewId
                                        );

                                        const division = divisions.find(
                                            (d) => d.id == crew.divisionId
                                        );

                                        return (
                                            <tr key={lts.id}>
                                                <td>
                                                    {crew && division && (
                                                        <LtsJobCard
                                                            event={{
                                                                id: lts.id,
                                                                text: crew.name,
                                                                crewColorHex:
                                                                    crew.colorHex,
                                                                divisionColorHex:
                                                                    division.colorHex,
                                                            }}
                                                        />
                                                    )}
                                                    {!(crew && division) && (
                                                        <>{crew.name}</>
                                                    )}
                                                </td>
                                                <td>
                                                    {moment(
                                                        lts.startDate
                                                    ).format(
                                                        MomentDateFormat.WeekDayNameAndDate
                                                    )}
                                                </td>
                                                <td>
                                                    {moment(lts.endDate).format(
                                                        MomentDateFormat.WeekDayNameAndDate
                                                    )}
                                                </td>
                                                <td>
                                                    <YesNoBadge
                                                        value={lts.isPublished}
                                                    />
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </Col>
                </Row>
            </>
        );
    }
}
